import React, { useContext, useEffect } from 'react';
import { useParams, useHistory, Redirect } from 'react-router';

import { Container, Gap } from 'components';
import { AuthContext, isOrgFeatureEnabled, useSpot } from 'framework';

import { UserInfo } from './user-info';

const REDIRECTED_TABS: Record<
  string,
  { path: string; feature: 'leave' | 'expenses' }
> = {
  leaveRequests: { path: 'leave', feature: 'leave' },
  leaveRemaining: { path: 'leave', feature: 'leave' },
  expenses: { path: 'expenses', feature: 'expenses' }
};

export function User() {
  const { organization, tab } = useParams<{
    organization: string;
    tab?: string;
  }>();
  const { getCurrentUser } = useContext(AuthContext);
  const { data, query } = useSpot();

  const history = useHistory();

  const handleTabChange = (selectedTab: string) => {
    history.replace(`/${organization}/user/${selectedTab}`);
  };

  const id = getCurrentUser();
  const org = data?.organizations?.[organization];

  useEffect(() => {
    if (!org) {
      query(`org/${organization}`, {}, ['organizations', organization]);
    }
  }, [org, organization, query]);

  if (tab && Object.prototype.hasOwnProperty.call(REDIRECTED_TABS, tab)) {
    if (!org) {
      return <></>;
    }

    const redirectTarget = REDIRECTED_TABS[tab];
    return (
      <Redirect
        to={
          isOrgFeatureEnabled(org, redirectTarget.feature)
            ? `/${organization}/${redirectTarget.path}`
            : `/${organization}`
        }
      />
    );
  }

  return (
    <Container>
      <UserInfo
        id={id}
        organization={organization}
        tab={tab}
        onTabChange={handleTabChange}
        disabledTabs={['applications', 'hourConfig', 'leaveConfig']}
      />
      <Gap />
    </Container>
  );
}
